import { Component, OnInit } from '@angular/core';
import { MobileAppWrapper } from '../mobile.app.wrapper.component';
import { JoiApp } from 'globals/store/app.data';
import { loadProgramTexts } from 'globals/store/programs.data';
import { getDefaultProgramTabNames } from 'globals/store/share.data';
import { SponsorGalleryComponent } from 'src/app/modules/sponsors/sponsor-gallery.component';
import { mobileAppFeature } from '../mobile-store/mobile.app.era';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'mobile-app-sponsors',
    template: `
<sponsor-gallery *ngIf="!!app?.eventData"
  [joiEvent]="app.eventData.eventInfo"
  [timeline]="app.eventData.timeline"
  [programTexts]="programTexts"
  [isPreview]="false"
  [entityName]="tabNames['sponsorsTab']"
  [hideTypes]="!!app.eventData.excludedFieldIds?.includes('sponsorProfileType')"
  [hideSessions]="!!app.eventData.excludedFieldIds?.includes('includeSponsorSessions')"
  [programTexts]="programTexts"
  (scrollUp)="scrollUp()"
></sponsor-gallery>
`,
    styleUrls: ['./mobile-entities.scss'],
    standalone: true,
    imports: [SponsorGalleryComponent, CommonModule]
})
export class MobileAppSponsorsComponent extends MobileAppWrapper<MobileAppSponsorsComponent>  {
  app: JoiApp
  programTexts = {}
  tabNames:{ [tId: string]: string } = getDefaultProgramTabNames() 

  constructor() {
    super()
    this.subCallback(this.store.select(mobileAppFeature.selectApp), app => {
      this.app = app
      if (!app) return
      const { tabNames, timeline, excludedFieldIds, eventInfo } = app.eventData
      if (tabNames) this.tabNames = tabNames
      this.programTexts = loadProgramTexts(timeline, excludedFieldIds, eventInfo.venues)
    })
  }

}

